const nextGameStyle = {
  section_wrapper: `w-full py-[30px] lg:py-[50px] px-4 bg-transparent flex flex-col items-center justify-center relative overflow-hidden`,
  container: `max-w-[1100px] w-full mx-auto flex flex-col items-center justify-center text-center bg-gradient-to-b from-[#0b133c]/85 to-[#040822]/90 border border-white/[0.08] rounded-[24px] backdrop-blur-md py-16 px-6 md:py-20 md:px-12 relative overflow-hidden shadow-2xl`,
  heading: `font-Suisse font-[900] uppercase text-[28px] leading-[36px] tracking-tight text-white mb-6
            screen-500:text-[36px] screen-500:leading-[44px]
            sm:text-[44px] sm:leading-[52px]
            md:text-[52px] md:leading-[62px]
            lg:text-[60px] lg:leading-[70px]`,
  highlight: `text-primaryHeading`,
  subtitle: `text-white/60 font-Suisse font-bold text-[11px] leading-[18px] tracking-[0.15em] uppercase mb-8
             screen-500:text-[12px]
             md:text-[14px]`,
  explore_btn: `!py-[12px] !px-[24px] max-w-[180px] w-full flex items-center justify-center rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl`,
};

export { nextGameStyle };